<div class="wrapper">
  <div class="heading-row flex justify-between items-center mb-[40px]">
    <div class="heading text-type-2">
      Item {{ data?.externalTestDetails?.bid_item?.item }}
    </div>
    <button
      mat-icon-button
      [matMenuTriggerFor]="moreMenu"
      class="more-menu-button"
      data-testid="offsite-test-more-menu"
    >
      <mat-icon>more_horiz</mat-icon>
    </button>
    <mat-menu #moreMenu="matMenu">
      <button
        mat-menu-item
        data-testid="offsite-test-download-pdf"
        [disabled]="downloadingReport"
        (click)="downloadPdf()"
      >
        <mat-icon>download</mat-icon>
        {{ downloadingReport ? 'Generating PDF…' : 'Download PDF' }}
      </button>
      <button *ngIf="canCancel" mat-menu-item (click)="cancelTest()">
        <mat-icon>cancel</mat-icon>
        Cancel test
      </button>
    </mat-menu>
  </div>
  @if (data?.externalTestDetails?.status === 'cancelled' && data?.externalTestDetails?.cancellation_reason) {
    <div class="cancellation-banner" data-testid="cancellation-banner">
      <div class="cancellation-header">
        <mat-icon class="cancellation-icon">close</mat-icon>
        <span class="cancellation-label" data-testid="cancellation-label">Cancelled</span>
      </div>
      <div class="cancellation-reason" data-testid="cancellation-reason">
        {{ data?.externalTestDetails?.cancellation_reason }}
      </div>
    </div>
  }
  <div class="accordion-section">
    @for (accordion of accordionConfig; track accordion; let first = $first; let last = $last) {
      <app-external-test-details-expandable-block
        (click)="!accordion.isDisabled ? expand(accordion) : {}"
        [data]="{accordion,externalTestDetails:data?.externalTestDetails}"
        [heading]="accordion?.heading"
        [id]="accordion?.id"
        [isExpanded]="selectedAccordionId === accordion?.id"
        [isFirst]="first"
        [isLast]="last"
        icon="daily-report-bid-item"
        >
        <ng-container>
          <div (click)="$event.stopPropagation()" class="panel bid-items-panel">
            @switch (accordion.heading) {
              @case ('Request') {
                <app-external-test-request-details [data]="data?.externalTestDetails" />
              }
              @case ('Schedule') {
                <app-external-test-schedule-details [data]="data?.externalTestDetails" />
              }
              @case ('Record') {
                <app-external-test-record-lab-test-details [data]="data?.externalTestDetails" />
              }
              @case ('Report') {
                <app-external-test-report-details [data]="data?.externalTestDetails" />
              }
              @case ('Result') {
                <app-external-test-result-details [data]="data?.externalTestDetails" />
              }
            }
          </div>
        </ng-container>
      </app-external-test-details-expandable-block>
    }
  </div>
</div>
